import React from 'react';
import {
  Button,
  StackLayout,
  HeadingText,
  ParagraphText,
  styled,
  GDSImageProps,
} from '@leagueplatform/genesis-core';
import { ButtonProps } from './landing.page.types';

const LogoImage = styled('img', {
  width: '270px',
  '@mobile': {
    width: '220px',
  },
  '@mobileLandscape': {
    width: '220px',
  },
});

/**
 * This is the section of the LandingPage that contains the main content of the screen.
 * This includes the Primary action button, optional logo and footer section.
 *
 * @returns {JSX.Element}
 */
export const SignInSection = ({
  logo,
  errorMessage,
  signInButton,
  secondaryButtons,
  footerSection,
}: {
  logo?: GDSImageProps;
  errorMessage?: string | null;
  signInButton: ButtonProps;
  secondaryButtons?: ButtonProps[];
  footerSection?: React.ReactNode;
}) => (
  <StackLayout
    orientation="vertical"
    horizontalAlignment="center"
    verticalAlignment="center"
    css={{
      width: '100%',
      padding: '$half',
    }}
  >
    <HeadingText
      size="xl"
      level="1"
      css={{
        marginBottom: '$three',
        '@mobile': {
          marginBottom: '$two',
        },
        '@mobileLandscape': {
          marginBottom: '$two',
        },
      }}
    >
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <LogoImage {...logo} />
    </HeadingText>
    <StackLayout css={{ gap: '$one' }}>
      <Button
        size="large"
        priority="primary"
        width="fillContainer"
        css={{
          maxWidth: 243,
          ...signInButton?.css,
        }}
        onClick={signInButton.onClick}
      >
        {signInButton.buttonText}
      </Button>
      {secondaryButtons &&
        secondaryButtons.map((button) => (
          <Button
            key={button.buttonText}
            size="large"
            priority="secondary"
            width="fillContainer"
            css={{
              maxWidth: 243,
              ...button?.css,
            }}
            as={button.isExternalLink ? 'a' : undefined}
            href={button.isExternalLink ? button.to : undefined}
            target={button.isExternalLink ? '_blank' : undefined}
            rel={button.isExternalLink ? 'noopener noreferrer' : undefined}
            // Only use onClick for non-external links
            onClick={!button.isExternalLink ? button.onClick : undefined}
          >
            {button.buttonText}
          </Button>
        ))}
    </StackLayout>
    {errorMessage && (
      <ParagraphText css={{ color: '$onSurfaceTextCritical', margin: '$one' }}>
        {errorMessage}
      </ParagraphText>
    )}
    {footerSection}
  </StackLayout>
);
